import { render } from "./HowToTrigger.vue?vue&type=template&id=77fa2655"
import script from "./HowToTrigger.vue?vue&type=script&lang=js"
export * from "./HowToTrigger.vue?vue&type=script&lang=js"

import "./HowToTrigger.vue?vue&type=style&index=0&id=77fa2655&lang=css"

import exportComponent from "C:\\NEW DTC 2021\\ecpv\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__